import React, { useState } from 'react';
import Logo from '../../assets/logo.png';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';

const FloatingNavbar = ({ handleScrollToSection = () => {}, visibleItems = [] }) => {
  const [nav, setNav] = useState(false);
  const [language, setLanguage] = useState('EN');

  const handleNav = () => setNav(!nav);
  const scrollAndClose = (id) => {
    handleScrollToSection(id);
    setNav(false);
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'EN' ? 'ಕನ್ನಡ' : 'EN'));
  };

  const shouldShow = (item) => visibleItems.includes(item);

  return (
    <>
      <div>
        <div className="fixed top-0 left-0 w-full h-32 bg-[#fcc76d]/10 backdrop-blur-md z-40" />

        {/* Navbar Layer */}
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 w-[95%] h-24 bg-[#3B250F] z-50 shadow-sm shadow-[#3B250F] rounded-full px-10 flex justify-between items-center">
          <img
            className="w-24 h-24 cursor-pointer"
            alt="logo"
            src={Logo}
            onClick={() => handleScrollToSection('home')}
          />

          <ul className="hidden md:flex text-[#E5F1F5] font-semibold text-[14px] lg:text-[18px] cursor-pointer space-x-10">
            {shouldShow('home') && <li onClick={() => handleScrollToSection('home')}>Home</li>}
            {shouldShow('about') && <li onClick={() => handleScrollToSection('about')}>About</li>}
            {shouldShow('services') && <li onClick={() => handleScrollToSection('services')}>Service</li>}
            {shouldShow('gallery') && <li onClick={() => handleScrollToSection('gallery')}>Gallery</li>}
            {shouldShow('sponsors') && <li onClick={() => handleScrollToSection('sponsors')}>Sponsors</li>}
            {shouldShow('contact') && <li onClick={() => handleScrollToSection('contact')}>Contact Us</li>}

            {shouldShow('language') && (
              <button
                onClick={toggleLanguage}
                className="ml-6 px-2 py-1 rounded-full bg-[#E5F1F5] text-[#3B250F] text-sm font-semibold hover:bg-white transition"
              >
                {language}
              </button>
            )}
          </ul>

          <div onClick={handleNav} className="block md:hidden cursor-pointer">
            {nav ? (
              <AiOutlineClose size={24} color="#E5F1F5" />
            ) : (
              <AiOutlineMenu size={24} color="#E5F1F5" />
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={
            nav
              ? 'fixed left-0 top-4 w-[60%] h-full z-50 bg-[#3B250F] ease-in-out duration-500'
              : 'fixed left-[-100%]'
          }
        >
          <img
            className="w-24 h-24 ml-4 cursor-pointer"
            alt="logo"
            src={Logo}
            onClick={() => scrollAndClose('home')}
          />
          <ul className="pt-24 p-4 text-[#E5F1F5] cursor-pointer font-semibold space-y-4 uppercase">
            {shouldShow('home') && <li onClick={() => scrollAndClose('home')}>Home</li>}
            {shouldShow('about') && <li onClick={() => scrollAndClose('about')}>About</li>}
            {shouldShow('services') && <li onClick={() => scrollAndClose('services')}>Service</li>}
            {shouldShow('gallery') && <li onClick={() => scrollAndClose('gallery')}>Gallery</li>}
            {shouldShow('sponsors') && <li onClick={() => scrollAndClose('sponsors')}>Sponsors</li>}
            {shouldShow('contact') && <li onClick={() => scrollAndClose('contact')}>Contact Us</li>}

            {shouldShow('language') && (
              <button
                onClick={toggleLanguage}
                className="px-2 py-1 rounded-full bg-[#E5F1F5] text-[#3B250F] text-sm font-semibold hover:bg-white transition"
              >
                {language}
              </button>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default FloatingNavbar;